import {useAppSelector} from "../../../redux/hooks";
import {mySongsFiltersStore} from "../../../pages/songs-router/modules/my-songs-filters-store/mySongsFiltersStore";

export interface IFilterGenresLogic {
  isAvailable: boolean;
  genreIds: number[];
}

export const useFilterGenresLogic = (): IFilterGenresLogic => {
  const isAvailable = useAppSelector((): boolean => mySongsFiltersStore.isFilterAvailable("genre"));
  const genreIds = useAppSelector(mySongsFiltersStore.getGenreIds);
  return {
    isAvailable,
    genreIds,
  };
}
